// Temporarily off. Set true to show the Super Admin menu and /app/super-admin again.
export const SUPER_ADMIN_FLOW_ENABLED = false
